export default {
    clearManualSelectionData: (state) => state.manualSelectionData = {},
    setManuallySelectedCableAndQuantity: (state, payload) => {
        state.manualSelectionData[payload.cableKey] = payload.quantity
    },
    setManualSelectionData: (state, manualSelectionData) => state.manualSelectionData = manualSelectionData,
}